import script from "./ButtonModule.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonModule.vue?vue&type=script&setup=true&lang=js"

import "./ButtonModule.vue?vue&type=style&index=0&id=4a3e85de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3e85de"]])

export default __exports__